var _circle, _mask, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 64,
    transform: "matrix(-1 0 0 1 64 64)",
    fill: "#EA84AB",
    fillOpacity: 0.32
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 128,
    height: 128
  }, /*#__PURE__*/React.createElement("circle", {
    r: 64,
    transform: "matrix(-1 0 0 1 64 64)",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.7478 100.265C21.6189 106.238 20.0544 127.998 20.0544 127.998H107.948C107.948 127.998 106.383 106.238 103.254 100.265C98.5611 91.3052 64.0011 79.7852 64.0011 79.7852C64.0011 79.7852 29.4411 91.3052 24.7478 100.265Z",
    fill: "#0033AB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.2952 100.693C62.2952 101.636 63.0593 102.4 64.0018 102.4C64.9444 102.4 65.7085 101.636 65.7085 100.693C65.7085 99.7504 64.9444 98.9863 64.0018 98.9863C63.0593 98.9863 62.2952 99.7504 62.2952 100.693ZM62.2952 109.228C62.2952 110.17 63.0593 110.934 64.0018 110.934C64.9444 110.934 65.7085 110.17 65.7085 109.228C65.7085 108.285 64.9444 107.521 64.0018 107.521C63.0593 107.521 62.2952 108.285 62.2952 109.228ZM64.0018 119.469C63.0593 119.469 62.2952 118.705 62.2952 117.762C62.2952 116.82 63.0593 116.056 64.0018 116.056C64.9444 116.056 65.7085 116.82 65.7085 117.762C65.7085 118.705 64.9444 119.469 64.0018 119.469Z",
    fill: "#141ED2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5334 74.8388L96.8486 66.462C100.266 48.3207 96.2126 36.8908 84.6886 32.1722C79.3613 14.7168 58.6263 16.1366 52.7493 17.5596C32.7489 22.4024 24.3436 41.4955 27.5334 74.8388Z",
    fill: "#DD0071"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.2393 84.9037V59.3037C84.9149 59.144 82.8328 40.6447 72.106 46.2904C70.186 47.1437 65.2793 44.797 66.986 39.037C55.466 47.5704 39.4129 32.594 38.3993 41.8104C36.4046 59.9483 40.2641 74.8564 50.4987 74.8574C51.5035 74.8575 52.4826 74.8915 53.7593 74.6637V84.9037C57.1001 86.8948 60.4408 87.8904 63.7816 87.8904C67.1223 87.8904 70.6082 86.8948 74.2393 84.9037Z",
    fill: "#FAE6E4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.7595 74.6638V78.0771C60.1595 78.0771 65.1373 75.0194 68.6929 68.9038C64.4262 71.7483 59.4484 73.6683 53.7595 74.6638Z",
    fill: "#EA84AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.0142 87.4544C61.0953 87.3149 53.76 85.8045 53.76 82.5416V79.7852C52.9775 79.7852 50.7369 81.6336 49.5847 83.1985C45.0294 89.3852 50.0822 94.9318 54.2028 94.9318C59.4024 94.9318 62.8472 90.5877 64 88.4976C65.1528 90.5877 68.5977 94.9318 73.7973 94.9318C77.9179 94.9318 82.9707 89.3852 78.4154 83.1985C77.2632 81.6336 75.0226 79.7852 74.24 79.7852V82.5416C74.24 85.8045 67.0978 87.3149 64.0142 87.4544Z",
    fill: "#141ED2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.8842248197c5e11fddd5aa9b8c81c891.svg";
export { ForwardRef as ReactComponent };